export default __webpack_public_path__ + "static/stickiness-dark-d6dbe0ea6fb501db4a6573d878c64f31.png";